const pageSize = 12;

const paggination = {
  pageSize,
};

export default paggination;
